import React from 'react'

const Modules = () => {
  return (
    <div>Modules</div>
  )
}

export default Modules